import axios from '@_system/axios/axios.js'
export default {
	path: '/BIshopflow',
	get(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	setTarget(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/setTarget', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	getTarget(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getTarget', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	formfield(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path+'/formfield', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	downcurrentday(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/downcurrentday', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},

}